import type { DBTypes } from '@openphone/dexie-database/types'
import uuid from '@openphone/lib/uuid'
import { makeAutoObservable, toJS } from 'mobx'
import type { MarkOptional } from 'ts-essentials'

import type { Model } from '@src/service/model/base'

export type RawWorkflowScheduleDefinition = DBTypes.WorkflowScheduleDefinitionRow

export default class WorkflowScheduleDefinitionModel implements Model {
  private raw: RawWorkflowScheduleDefinition

  get id() {
    return this.raw.id
  }

  get version() {
    return this.raw.version
  }

  get orgId() {
    return this.raw.orgId
  }

  get entityId() {
    return this.raw.entityId
  }

  get trigger() {
    return this.raw.trigger
  }

  get triggerDefinitionId() {
    return this.raw.trigger.definitionId
  }

  get workflow() {
    return this.raw.workflow
  }

  get workflowDefinitionId() {
    return this.raw.workflow.definitionId
  }

  get scheduledFor() {
    return this.raw.scheduledFor
  }

  get scheduledForDate() {
    return new Date(this.raw.scheduledFor)
  }

  get configuration() {
    return this.raw.configuration
  }

  get createdAt() {
    return this.raw.createdAt
  }

  get createdBy() {
    return this.raw.createdBy
  }

  get updatedAt() {
    return this.raw.updatedAt
  }

  get updatedBy() {
    return this.raw.updatedBy
  }

  get deletedAt() {
    return this.raw.deletedAt
  }

  get deletedBy() {
    return this.raw.deletedBy
  }

  constructor(attrs: MarkOptional<RawWorkflowScheduleDefinition, 'id'>) {
    this.raw = {
      ...attrs,
      id: attrs.id ?? `WSCH${uuid()}`.replace(/-/g, ''),
    }

    makeAutoObservable<this>(this)
  }

  deserialize(json: RawWorkflowScheduleDefinition): this {
    this.raw = json
    return this
  }

  serialize(): RawWorkflowScheduleDefinition {
    return toJS(this.raw)
  }
}
